module.exports = __webpack_public_path__ + "static/media/left_btn_24.db5b226b.svg";